export default __webpack_public_path__ + "static/media/SmileOutlined.d66d1075.svg";